import { Links, Meta, Outlet, Scripts, ScrollRestoration } from 'react-router'
import { Toaster } from '@/component/ui/sonner'
import './theme.css'
import './app.css'
// import './hover.css'
import './zy-hover.css'
import 'virtual:track'
import { Spinner } from './component'
import { setErrorMap } from 'zod'
import customErrorMap from './lib/zod-error-messages'
import { ErrorBoundary } from './bc'
// 设置全局错误消息
setErrorMap(customErrorMap)

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="https://cdn.zhiyitech.cn/material/b06ac94e90415260bff42e78d8cd0a8e" />
        <title>知小布</title>
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <Toaster />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

export function HydrateFallback() {
  return <Spinner />
}
export default function App() {
  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  )
}
